import React from 'react';
import { Box, Typography, TextField, Button, MenuItem, Grid } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

const OrganizationForm = ({ handleClose, onSubmit, initialData }) => {
  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: initialData || {
      org_id: '',
      name: '',
      org_type: 'INDEPENDENT',
      headquarters_country: '',
      tax_id: '',
      website_url: '',
      support_email: '',
      support_phone: '',
      commission_rate: '',
      currency: 'INR'
    }
  });

  const orgTypes = ['CHAIN', 'GROUP', 'INDEPENDENT', 'MANAGEMENT_COMPANY'];
  const currencies = ['INR'];

  return (
    <Box component="form" sx={{ bgcolor: 'background.paper', borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
        {initialData ? 'Edit Organization' : 'New Organization'}
      </Typography>
      <Grid container spacing={2}>
        {[
          // { 
          //   name: 'org_id', 
          //   label: 'Organization ID', 
          //   required: true, 
          //   type: 'number',
          //   rules: {
          //     required: 'Organization ID is required',
          //     pattern: {
          //       value: /^[0-9]+$/,
          //       message: 'Please enter a valid integer'
          //     }
          //   }
          // },
          { 
            name: 'name', 
            label: 'Organization Name', 
            required: true,
            rules: {
              required: 'Organization Name is required',
              maxLength: {
                value: 100,
                message: 'Name cannot exceed 100 characters'
              }
            }
          },
          { 
            name: 'org_type', 
            label: 'Organization Type', 
            required: true, 
            select: orgTypes 
          },
          { 
            name: 'headquarters_country', 
            label: 'Headquarters Country', 
            required: true,
            rules: {
              required: 'Country is required',
              maxLength: {
                value: 50,
                message: 'Country name cannot exceed 50 characters'
              }
            }
          },
          { 
            name: 'tax_id', 
            label: 'Tax ID', 
            required: true,
            rules: {
              required: 'Tax ID is required',
              maxLength: {
                value: 50,
                message: 'Tax ID cannot exceed 50 characters'
              }
            }
          },
          { 
            name: 'website_url', 
            label: 'Website URL', 
            required: true,
            rules: {
              required: 'Website URL is required',
              maxLength: {
                value: 255,
                message: 'URL cannot exceed 255 characters'
              }
            }
          },
          { 
            name: 'support_email', 
            label: 'Support Email', 
            required: true, 
            type: 'email',
            rules: {
              required: 'Email is required',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Invalid email address'
              },
              maxLength: {
                value: 100,
                message: 'Email cannot exceed 100 characters'
              }
            }
          },
          { 
            name: 'support_phone', 
            label: 'Support Phone', 
            required: true,
            rules: {
              required: 'Phone number is required',
              maxLength: {
                value: 20,
                message: 'Phone number cannot exceed 20 characters'
              }
            }
          },
          { 
            name: 'commission_rate', 
            label: 'Commission Rate (%)', 
            required: true, 
            type: 'number',
            rules: {
              required: 'Commission rate is required',
              min: {
                value: 0,
                message: 'Commission rate must be at least 0'
              },
              max: {
                value: 99.99,
                message: 'Commission rate cannot exceed 99.99'
              }
            }
          },
          { 
            name: 'currency', 
            label: 'Currency', 
            required: true, 
            select: currencies 
          }
        ].map(({ name, label, required, select, type, rules }) => (
          <Grid item xs={12} sm={6} key={name}>
            <Controller
              name={name}
              control={control}
              rules={rules || (required ? { required: `${label} is required` } : {})}
              render={({ field }) => (
                <TextField
                  {...field}
                  size="small"
                  label={label}
                  fullWidth
                  select={!!select}
                  type={type || 'text'}
                  error={!!errors[name]}
                  helperText={errors[name]?.message || ''}
                >
                  {select && select.map(option => (
                    <MenuItem key={option} value={option}>
                      {option.replace('_', ' ')}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />
          </Grid>
        ))}
      </Grid>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 2 }}>
        <Button onClick={handleClose} variant="outlined">Cancel</Button>
        <Button onClick={handleSubmit(onSubmit)} variant="contained" color="primary">
          {initialData ? 'Update' : 'Save'}
        </Button>
      </Box>
    </Box>
  );
};

export default OrganizationForm;
